import { reportsModelFieldsRetrieveOptions } from '@crm/api'
import { ViewFiltersFieldValue } from '@crm/features/leads/components'

import { useQuery } from '@tanstack/react-query'
import { Form } from 'antd'
import { useParams } from 'react-router-dom'

import { TaskFormElement } from './types'

type Props = {
  key: number
  element: TaskFormElement
  values?: Record<string, string>
  className?: string
  required?: boolean
}

export const ValueElement = ({
  key,
  element,
  className,
  values,
  required
}: Props) => {
  const { id: reportId } = useParams()

  const { data: fieldsData } = useQuery(
    reportsModelFieldsRetrieveOptions({ path: { id: Number(reportId) } })
  )

  return (
    <Form.Item
      name={element.name}
      key={key}
      label={element.label}
      className={className}
      rules={[{ required }]}
    >
      <ViewFiltersFieldValue
        viewsFields={fieldsData}
        numberOfElement={0}
        filters={[
          {
            field_name: values?.field_name,
            filter_operator: values?.filter_operator,
            value: values?.[element?.name]
              ? [values?.[element?.name]]
              : undefined,
            order: 0
          }
        ]}
      />
    </Form.Item>
  )
}
